export default {
  props: {
    type: {
      type: String,
      default: 'button'
    },
    to: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'normal'
    },
    rounded: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      width: ''
    }
  },

  watch: {
    loading (value) {
      this.width = value ? this.$el.offsetWidth + 'px' : ''
    }
  },

  computed: {
    tag () {
      let tag

      switch (this.type) {
        case 'link':
          tag = 'a'
          break
        case 'router-link':
          tag = 'router-link'
          break
        default:
          tag = 'button'
          break
      }

      return tag
    }
  }
}
